/**
* @file 框架-顶部-司机注册二维码弹窗
* @description 司机注册二维码弹窗，支持下载二维码和物料图
* @version 1.2.0
* */
<template>
  <el-dialog 
    :visible.sync="visible" 
    width="460px" 
    :close-on-click-modal="false"
    :show-close="false"
    class="driver-register-dialog"
    append-to-body
  >
    <!-- 自定义头部 -->
    <div slot="title" class="dialog-header">
      <div class="header-icon">
        <i class="el-icon-user-solid"></i>
      </div>
      <div class="header-text">
        <h3>司机注册</h3>
        <p>扫码注册成为平台司机</p>
      </div>
      <button class="close-btn" @click="visible = false">
        <i class="el-icon-close"></i>
      </button>
    </div>
    
    <div class="dialog-content">
      <div class="qrcode-wrapper">
        <div class="qrcode-decoration">
          <div class="corner corner-tl"></div>
          <div class="corner corner-tr"></div>
          <div class="corner corner-bl"></div>
          <div class="corner corner-br"></div>
        </div>
        <div class="qrcode-container download_material_down">
          <vue-qr 
            class="qr-code-down2" 
            :text="qrcodeUrl" 
            :margin="10" 
            colorDark="#FF6633" 
            :size="200" 
          />
        </div>
        <div class="scan-line"></div>
      </div>
      
      <div class="info-section">
        <div class="info-item">
          <i class="el-icon-check"></i>
          <span>快速注册，简单便捷</span>
        </div>
        <div class="info-item">
          <i class="el-icon-check"></i>
          <span>实名认证，安全可靠</span>
        </div>
      </div>
      
      <!-- 隐藏的物料图用于下载 -->
      <div class="download_material download_material_down">
        <img class="bg" :src="bg" alt="">
        <vue-qr 
          class="qr-code download_material_code" 
          :text="qrcodeUrl" 
          :margin="12" 
          colorDark="#FF6633" 
          height="300"
          width="300" 
        />
      </div>
      <div class="download_material1 download_material_down">
        <img class="bg" :src="bg1" alt="">
        <vue-qr 
          class="qr-code download_material_code" 
          :text="qrcodeUrl" 
          :margin="12" 
          colorDark="#FF6633" 
          height="280"
          width="280" 
        />
        <vue-qr 
          class="qr-code-down download_material_code1" 
          :text="qrcodeText" 
          :margin="11" 
          colorDark="#7EBF50"
          :size="350" 
        />
      </div>
      
      <div class="button-group">
        <el-button class="btn-cancel" @click="visible = false">
          取消
        </el-button>
        <el-button type="primary" class="btn-download" @click="download">
          <i class="el-icon-download"></i>
          <span>下载物料</span>
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VueQr from "vue-qr"
import { download } from '@/assets/js/domToImgAndDownloadZip'

export default {
  name: 'DriverRegisterDialog',
  components: { VueQr },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    qrcodeUrl: {
      type: String,
      default: ''
    },
    qrcodeText: {
      type: String,
      default: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      bg: require("@/assets/img/download_register.png"),
      bg1: require("@/assets/img/flow_chart.png")
    }
  },
  methods: {
    download() {
      this.$nextTick(() => {
        download(
          document.querySelectorAll(".download_material_down"), 
          ["司机注册二维码", "司机注册物料图", "司机认证物料图"]
        )
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-content {
  padding: 0 20px 20px;
}

.qrcode-wrapper {
  text-align: center;
  padding: 30px;
  background: linear-gradient(135deg, #fff5f2 0%, #ffe8e0 50%, #fff5f2 100%);
  border-radius: 16px;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  
  // 装饰角
  .qrcode-decoration {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 230px;
    height: 230px;
    pointer-events: none;
    
    .corner {
      position: absolute;
      width: 20px;
      height: 20px;
      border: 3px solid #FF6633;
      
      &.corner-tl {
        top: 0;
        left: 0;
        border-right: none;
        border-bottom: none;
        border-radius: 4px 0 0 0;
      }
      
      &.corner-tr {
        top: 0;
        right: 0;
        border-left: none;
        border-bottom: none;
        border-radius: 0 4px 0 0;
      }
      
      &.corner-bl {
        bottom: 0;
        left: 0;
        border-right: none;
        border-top: none;
        border-radius: 0 0 0 4px;
      }
      
      &.corner-br {
        bottom: 0;
        right: 0;
        border-left: none;
        border-top: none;
        border-radius: 0 0 4px 0;
      }
    }
  }
  
  .qrcode-container {
    display: inline-block;
    padding: 12px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(255, 102, 51, 0.2);
    position: relative;
    z-index: 1;
  }
  
  // 扫描线动画
  .scan-line {
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 2px;
    background: linear-gradient(90deg, transparent, #FF6633, transparent);
    animation: scan 2s ease-in-out infinite;
    opacity: 0.8;
  }
}

@keyframes scan {
  0%, 100% {
    top: 30px;
    opacity: 0;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    top: calc(100% - 30px);
    opacity: 0;
  }
}

.info-section {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  
  .info-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #64748b;
    
    i {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: linear-gradient(135deg, #FF6633 0%, #FF8855 100%);
      color: #fff;
      font-size: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
    }
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 16px;
  
  .el-button {
    min-width: 140px;
    height: 44px;
    border-radius: 22px;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.3s ease;
    
    i {
      margin-right: 6px;
    }
    
    &.btn-cancel {
      border: 2px solid #e2e8f0;
      color: #475569;
      
      &:hover {
        border-color: #FF6633;
        color: #FF6633;
        background: #fff5f2;
      }
    }
    
    &.btn-download {
      background: linear-gradient(135deg, #FF6633 0%, #e55a2b 100%);
      border: none;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(255, 102, 51, 0.4);
      }
    }
  }
}

// 隐藏的物料图
.download_material {
  width: 750px;
  height: 1620px;
  position: fixed;
  top: 9999px;
  left: 9999px;
  z-index: -1;

  .bg {
    width: 750px;
    height: 1620px;
  }

  .download_material_code {
    position: absolute;
    top: 533px;
    left: 226px;
  }
}

.download_material1 {
  width: 750px;
  height: 7030px;
  position: relative;
  position: fixed;
  top: 9999px;
  left: 9999px;
  z-index: -1;

  .download_material_code {
    position: absolute;
    top: 564px;
    left: 236px;
  }

  .download_material_code1 {
    position: absolute;
    bottom: 306px;
    left: 200px;
  }
}
</style>

<!-- 全局样式 -->
<style lang="less">
.driver-register-dialog {
  .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  }
  
  .el-dialog__header {
    padding: 0;
    margin: 0;
  }
  
  .el-dialog__body {
    padding: 0;
  }
  
  .dialog-header {
    display: flex;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #FF6633 0%, #e55a2b 100%);
    color: #fff;
    position: relative;
    
    .header-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.2);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;
      
      i {
        font-size: 24px;
      }
    }
    
    .header-text {
      flex: 1;
      
      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
      }
      
      p {
        margin: 4px 0 0;
        font-size: 13px;
        opacity: 0.9;
      }
    }
    
    .close-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: none;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover {
        background: rgba(255, 255, 255, 0.3);
        transform: rotate(90deg);
      }
      
      i {
        font-size: 16px;
      }
    }
  }
}
</style>
